module.exports = __webpack_public_path__ + "media/LandingPageAssets/InstagramIcon-d727e034.svg";